// =============================================
// SuccessToast — shared animated success message
// Kipikid - מערכת נוכחות ילדים בגנים
// =============================================

import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

interface SuccessToastProps {
  message: string;
  color?: string;
}

export function SuccessToast({ message, color = '#166534' }: SuccessToastProps) {
  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px 16px',
            marginBottom: '16px',
            borderRadius: '10px',
            background: '#dcfce7',
            color,
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          <CheckCircle2 size={18} />
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
